var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficiencyAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-993,-22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,199.71,-1682.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "efficiencyAlt",
    transform: "matrix(1,0,0,1,-5.35099,6.48236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,575.019,306.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(0,146,76)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.148534,0,0,0.083377,619.515,851.487)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03976,0,0,1.03976,-114.893,-129.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1616.74,966.343C1647.65,1009.48 1665.85,1062.33 1665.85,1119.39C1665.85,1264.66 1547.91,1382.59 1402.64,1382.59C1369.49,1382.59 1337.76,1376.45 1308.53,1365.24",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "24.69px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.04311,7.22493,-7.22493,9.04311,890.402,661.605)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0374378,0,0,0.0401106,19.7988,13.2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L922.626,312.408",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "28.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0374378,0,0,0.0401106,19.7988,8.80665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L921.412,312.451",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "28.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0380199,0,0,0.0394155,19.3134,13.3787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.332,256.301C664.813,184.261 728.853,164.091 831.748,162.735L834.236,351.489C724.41,350.755 663.839,330.095 664.332,256.301Z",
    style: {
      fill: "rgb(0,146,76)",
      stroke: "white",
      strokeWidth: "28.63px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-9.02927,-7.24222,7.24222,-9.02927,1795.97,1407.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0374378,0,0,0.0401106,19.7988,13.2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L922.626,312.408",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "28.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0374378,0,0,0.0401106,19.7988,8.80665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L921.412,312.451",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "28.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0380199,0,0,0.0394155,19.3134,13.3787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.332,256.301C664.813,184.261 728.853,164.091 831.748,162.735L834.236,351.489C724.41,350.755 663.839,330.095 664.332,256.301Z",
    style: {
      fill: "rgb(0,146,76)",
      stroke: "white",
      strokeWidth: "28.63px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03976,0,0,1.03976,-114.893,-129.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1185.53,1268.14C1156.46,1225.81 1139.44,1174.57 1139.44,1119.39C1139.44,974.125 1257.38,856.188 1402.64,856.188C1432.44,856.188 1461.08,861.149 1487.79,870.289",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "24.69px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.803296,0,0,0.450916,644.615,276.658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.916,1487.07C205.916,1487.07 206.823,1477.59 201.253,1469.15C195.771,1460.84 195.085,1456.46 194.9,1449.66C194.616,1439.16 201.709,1429.63 216.426,1429.23C230.499,1428.85 238.39,1439.02 238.601,1449.2C238.943,1465.8 229.016,1465.54 227.985,1487.16C227.962,1487.64 205.923,1487.49 205.916,1487.07Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00856,0,0,0.56614,600.329,105.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.079,1490.49C214.095,1490.63 219.135,1490.66 224.196,1490.59",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.89px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,3.1994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.079,1490.49C214.061,1490.63 219.097,1490.67 224.196,1490.59",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,6.19523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.079,1490.49L224.196,1490.59",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.771309,-0.00666793,0.00514315,0.999978,41.7858,10.6904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.079,1490.49L224.196,1490.59",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.12px"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiencyAlt);
export default __webpack_public_path__ + "static/media/efficiencyAlt.ee58b614bbc10de34e998a094823382c.svg";
export { ForwardRef as ReactComponent };